var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { BehaviorSubject } from "rxjs";
import jwtDecode from "jwt-decode";
import {
  ACCESS_TOKEN_KEY,
  LMS_BASE_URL,
  REFRESH_TOKEN_KEY,
  STUDENT_LOGOUT_URL,
  AUTH_API_URL
} from "../config/app-config";
import { loginApiRequest, studentApiAuthRequest } from "./client";
import JsCookie from "js-cookie";
import axios from "axios";
function getCookieDomainName() {
  const domainName = location.hostname.split(".").slice(-2).join(".");
  return domainName === "localhost" ? domainName : `.${domainName}`;
}
const Cookies = JsCookie.withAttributes({
  path: "/",
  domain: getCookieDomainName()
});
var AuthenticatedUserAccess = /* @__PURE__ */ ((AuthenticatedUserAccess2) => {
  AuthenticatedUserAccess2[AuthenticatedUserAccess2["BLOCKED"] = 0] = "BLOCKED";
  AuthenticatedUserAccess2[AuthenticatedUserAccess2["INSTRUCTIONS_AND_ASSIGNMENTS"] = 1] = "INSTRUCTIONS_AND_ASSIGNMENTS";
  AuthenticatedUserAccess2[AuthenticatedUserAccess2["FULL_ACCESS"] = 2] = "FULL_ACCESS";
  AuthenticatedUserAccess2[AuthenticatedUserAccess2["PRETESTS_AND_QUIZZES"] = 3] = "PRETESTS_AND_QUIZZES";
  return AuthenticatedUserAccess2;
})(AuthenticatedUserAccess || {});
let getAccessToken = () => {
  return Cookies.get(ACCESS_TOKEN_KEY);
};
const auth$ = new BehaviorSubject({
  error: null,
  isLoading: true,
  isAuthenticated: false
});
function overrideGetAccessTokenFn(fn) {
  getAccessToken = fn;
}
function setAccessToken(accessToken) {
  if (accessToken) {
    Cookies.set(ACCESS_TOKEN_KEY, accessToken);
  } else {
    Cookies.remove(ACCESS_TOKEN_KEY);
  }
}
function getRefreshToken() {
  return Cookies.get(REFRESH_TOKEN_KEY);
}
function getLmsUrl() {
  return Cookies.get(LMS_BASE_URL);
}
function getRealmFromBaseLMSUrl() {
  var _a;
  const urlParts = (_a = getLmsUrl()) == null ? void 0 : _a.split(".");
  return urlParts ? urlParts[0] : "";
}
function setRefreshToken(refreshToken) {
  if (refreshToken) {
    Cookies.set(REFRESH_TOKEN_KEY, refreshToken);
  } else {
    Cookies.remove(REFRESH_TOKEN_KEY);
  }
}
function fetchLogin({ username, password }) {
  return loginApiRequest({
    url: `/Security/Authenticate`,
    method: "POST",
    data: {
      Username: username,
      Password: password
    }
  });
}
function fetchRefreshAuthTokens() {
  const accessToken = getAccessToken();
  const headers = {
    Accept: "application/json",
    Authorization: `Bearer ${accessToken}`
  };
  return axios.post(`${AUTH_API_URL}/Refresh`, void 0, {
    headers,
    withCredentials: true
  });
}
function getAuthenticatedUser() {
  return getDecodedToken();
}
const isImpersonatingUser = () => {
  const user = getAuthenticatedUser();
  return user.requestinguserid != null && user.requestinguserid != "";
};
function isValidToken() {
  const decoded = getDecodedToken();
  if (!decoded) {
    return false;
  }
  const now = Date.now().valueOf() / 1e3;
  return now < decoded.exp;
}
function login(username, password) {
  auth$.next({
    error: null,
    isLoading: true,
    isAuthenticated: false
  });
  return fetchLogin({ username, password }).then((res) => __async(this, null, function* () {
    if (res) {
      const accessToken = res.m_Item3;
      const refreshToken = res.m_Item4;
      if (accessToken) {
        setAccessToken(accessToken);
        setRefreshToken(refreshToken);
        auth$.next({
          error: null,
          isLoading: false,
          isAuthenticated: true
        });
      } else {
        console.error(res.m_Item2);
        yield fetchEdgeExLogin({ username, password });
      }
    }
  })).catch((error) => __async(this, null, function* () {
    console.error(error);
    yield fetchEdgeExLogin({ username, password });
  }));
}
function logout() {
  setAccessToken(null);
  setRefreshToken(null);
  auth$.next({
    error: null,
    isLoading: false,
    isAuthenticated: false,
    logoutURL: getLmsUrl() ? `https://${getLmsUrl()}/student/authentication/logout` : STUDENT_LOGOUT_URL
  });
}
function getDecodedToken() {
  try {
    const jwt = getAccessToken();
    return jwtDecode(jwt);
  } catch (e) {
    console.error(`Invalid token`, e);
    return null;
  }
}
function getDecodedSessionToken(jwt) {
  try {
    return jwtDecode(jwt);
  } catch (e) {
    console.error(`Invalid token`, e);
    return null;
  }
}
const fetchEdgeExLogin = ({ username, password }) => {
  return studentApiAuthRequest({
    url: `/login`,
    method: "POST",
    data: {
      username,
      password
    }
  }).then((res) => {
    if (res) {
      const accessToken = res.access_token;
      const refreshToken = res.refresh_token;
      setAccessToken(accessToken);
      setRefreshToken(refreshToken);
      auth$.next({
        error: null,
        isLoading: false,
        isAuthenticated: true
      });
    }
  }).catch((error) => {
    console.error(error);
    auth$.next({
      error,
      isLoading: false,
      isAuthenticated: false
    });
  });
};
function refreshAuthTokens() {
  return fetchRefreshAuthTokens().catch((err) => {
    console.error("Refresh tokens error: ", err);
  });
}
export {
  AuthenticatedUserAccess,
  auth$,
  fetchLogin,
  fetchRefreshAuthTokens,
  getAccessToken,
  getAuthenticatedUser,
  getCookieDomainName,
  getDecodedSessionToken,
  getLmsUrl,
  getRealmFromBaseLMSUrl,
  getRefreshToken,
  isImpersonatingUser,
  isValidToken,
  login,
  logout,
  overrideGetAccessTokenFn,
  refreshAuthTokens,
  setAccessToken,
  setRefreshToken
};
